import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppConstants } from 'src/app/utilities/app-constants';
import { BatonFeature } from 'src/app/models/baton-features';
import { FolioEnums } from 'src/app/utilities/folio-enums';

@Injectable({
    providedIn: 'root'
})
export class NavDataService {
    private navDataSource = new BehaviorSubject({});
    navData = this.navDataSource.asObservable();

    constructor() { }

    load() {
        this.navDataSource.next(JSON.parse(localStorage.getItem(AppConstants.PARAM_LOCAL_STORAGE_NAV_ITEMS)));
    }

    navListItems(data: BatonFeature[]) {
        localStorage.removeItem(AppConstants.PARAM_LOCAL_STORAGE_NAV_ITEMS);
        localStorage.setItem(AppConstants.PARAM_LOCAL_STORAGE_NAV_ITEMS, JSON.stringify(data));
        this.setDefaultRoute(data);
        this.navDataSource.next(data);
    }

    setDefaultRoute(navItems: BatonFeature[]) {
        if (!navItems.length) {
            return;
        }
        let defaultRoute = `/${AppConstants.PARAM_ROUTE_VALUE_TEAMS}`;

        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < navItems.length; i++) {
            const navItem = navItems[i];
            if (navItem.FEATURE_NAME === FolioEnums.features.team) {
                defaultRoute = `/${AppConstants.PARAM_ROUTE_VALUE_TEAMS}`;
                localStorage.setItem(AppConstants.PARAM_LOCAL_STORAGE_DEFAULT_ROUTE, defaultRoute);
                return;
            } else {
                defaultRoute = `/${AppConstants.PARAM_ROUTE_VALUE_WORKSHOPS}`;
                localStorage.setItem(AppConstants.PARAM_LOCAL_STORAGE_DEFAULT_ROUTE, defaultRoute);
                return;
            }
        }

    }

}
